/**
 * Cloudinary / image-CDN transform tokens and file-like segments that scrapers
 * append onto /hotels/location/... paths. Joined into place "names" like
 * "jiaoxi, w_1200" or "pokolbin, nsw, dpr_2.0, 8d2cc64monviv73whp4.webp",
 * these always 404 on slug-lookup — skip the svc-search call entirely.
 */
const IMAGE_TRANSFORM_SEGMENT = /^(?:w_\d+|h_\d+|dpr_[\d.]+|c_(?:fill|scale|fit|crop|limit|pad|thumb)|g_(?:auto|west|east|north|south|center|face)|ar_[\d.]+|q_auto(?::[\w]+)?|q_\d+|fl_progressive)$/i
const IMAGE_FILE_SEGMENT = /\.(?:webp|jpe?g|png|gif|svg)$/i

/**
 * Returns true when a slug-lookup request is known-invalid garbage and should
 * not be sent to svc-search.
 */
export function shouldSkipPlaceSlugLookup(location: string): boolean {
  if (!location.trim()) return true

  return location
    .split(',')
    .map(part => part.trim())
    .filter(Boolean)
    .some(part => IMAGE_TRANSFORM_SEGMENT.test(part) || IMAGE_FILE_SEGMENT.test(part))
}
